module.exports = __webpack_public_path__ + "static/media/hubs3.9fe1c424.png";